module.exports = __webpack_public_path__ + "static/media/icon_card_money.284cd8bf.svg";